import React from 'react';
import { useNavigate } from 'react-router-dom';

const AgeConfirmationModal = ({ show, onClose, onConfirm }) => {
  const navigate = useNavigate();

  if (!show) return null;

  const handleConfirm = () => {
    onClose();
    if (onConfirm) onConfirm();
    else navigate('/login');
  };

  const handleExit = () => {
    onClose();
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999
      }}
    >
      <div
        style={{
          background: 'linear-gradient(-180deg, #14805e 0%, #184438 100%)',
          borderRadius: '0px',
          padding: '30px 24px 16px',
          maxWidth: '420px',
          width: '96%',
          maxHeight: '90vh',
          overflowY: 'auto',
          position: 'relative',
          color: '#fff',
          textAlign: 'center'
        }}
      >
        {/* Close button */}
        <div
          role="button"
          tabIndex={0}
          onClick={handleExit}
          onKeyDown={(e) => e.key === 'Enter' && handleExit()}
          style={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            backgroundColor: '#058016',
            // border: '2px solid #fff',
            borderRadius: '50%',
            width: '28px',
            height: '28px',
            color: '#000',
            fontSize: '18px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 'bold',
            lineHeight: 1,
            userSelect: 'none'
           
          }}
        >
          ×
        </div>

        {/* Title */}
        <h2
          style={{
            fontSize: '16px',
            fontWeight: 'bold',
            marginBottom: '16px',
            marginTop: '4px'
          }}
        >
          Non-Gambling Territories.
        </h2>

        {/* Divider */}
        <hr style={{ border: 'none', borderTop: '1px solid rgba(255,255,255,0.6)', marginBottom: '18px' }} />

        {/* First paragraph */}
        <p
          style={{
            fontSize: '14px',
            fontWeight: 'bold',
            lineHeight: '1.6',
            marginBottom: '24px'
          }}
        >
          Connecting to our site from non gambling countries, it will be User's
          responsibility to ensure that their use of the service is lawful.
        </p>

        {/* Underage heading */}
        <h2
          style={{
            fontSize: '16px',
            fontWeight: 'bold',
            marginBottom: '16px',
            marginTop: '28px'
          }}
        >
          Underage gambling is prohibited.
        </h2>

        {/* Divider */}
        <hr style={{ border: 'none', borderTop: '1px solid rgba(255,255,255,0.6)', marginBottom: '20px' }} />

        {/* Second paragraph */}
        <p
          style={{
            fontSize: '14px',
            fontWeight: 'bold',
            lineHeight: '1.6',
            marginBottom: '28px'
          }}
        >
          Please confirm if you are 18 years old and above as of today.
        </p>

        {/* Buttons */}
        <div
          style={{
            display: 'flex',
            gap: '16px',
            justifyContent: 'center',
            marginTop: '32px',
            marginBottom: '0px',
            paddingBottom: '0px'
          }}
        >
          <div
            role="button"
            tabIndex={0}
            onClick={handleConfirm}
            onKeyDown={(e) => e.key === 'Enter' && handleConfirm()}
            style={{
              backgroundColor: '#fff',
              color: '#000',
              border: '2px solid #fff',
              borderRadius: '6px',
              padding: '4px 0',
              fontSize: '14px',
              fontWeight: 'bold',
              cursor: 'pointer',
              display: 'inline-block',
              userSelect: 'none',
              width: '120px',
              textAlign: 'center'
            }}
          >
            Confirm
          </div>
          <div
            role="button"
            tabIndex={0}
            onClick={handleExit}
            onKeyDown={(e) => e.key === 'Enter' && handleExit()}
            style={{
              backgroundColor: '#000',
              color: '#fff',
              border: '2px solid #fff',
              borderRadius: '6px',
              padding: '4px 0',
              fontSize: '14px',
              fontWeight: 'bold',
              cursor: 'pointer',
              display: 'inline-block',
              userSelect: 'none',
              width: '120px',
              textAlign: 'center'
            }}
          >
            Exit
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgeConfirmationModal;
